import React, { useEffect, useState } from 'react';
import axios from 'axios';

export default function AdminAnnounce() {
  const [list, setList]   = useState([]);
  const [form, setForm]   = useState({ title:'', body:'', target:'all' });
  const [saving, setSaving] = useState(false);
  const [msg, setMsg]     = useState('');

  const load = () => axios.get('/admin/announcements').then(r => setList(r.data));
  useEffect(() => { load(); }, []);

  const handlePost = async e => {
    e.preventDefault(); setSaving(true);
    try { await axios.post('/admin/announcements', form); setMsg('Posted!'); setForm({ title:'', body:'', target:'all' }); load(); }
    catch { setMsg('Error.'); } finally { setSaving(false); }
  };

  return (
    <div>
      <div className="page-header"><div><h1 className="page-title">Announcements</h1><p className="page-sub">Post notices to members</p></div></div>
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:18 }}>
        <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
          {list.length === 0 && <div className="card" style={{ padding:24 }}><div className="empty-state"><p>No announcements yet.</p></div></div>}
          {list.map(a => (
            <div key={a.id} className="card" style={{ padding:18 }}>
              <div style={{ display:'flex', justifyContent:'space-between', marginBottom:8 }}>
                <div style={{ fontSize:14, fontWeight:600 }}>{a.title}</div>
                <span className="badge badge-muted">{a.target}</span>
              </div>
              <div style={{ fontSize:13, color:'var(--text-secondary)', lineHeight:1.6, marginBottom:10 }}>{a.body}</div>
              <div style={{ fontSize:11, color:'var(--text-muted)' }}>By {a.author} · {new Date(a.created_at).toLocaleDateString('en-GB', { day:'2-digit', month:'short', year:'numeric' })}</div>
            </div>
          ))}
        </div>

        <div className="card">
          <div className="card-header"><div className="card-title">📢 Post announcement</div></div>
          <form onSubmit={handlePost} style={{ padding:20 }}>
            {msg && <div style={{ marginBottom:14, padding:'10px 14px', borderRadius:'var(--radius)', background:'var(--success-dim)', color:'var(--success)', fontSize:13 }}>{msg}</div>}
            <div className="form-group"><label className="label">Title *</label><input className="input" placeholder="e.g. Eid holiday timings" value={form.title} onChange={e => setForm(p=>({...p,title:e.target.value}))} required /></div>
            <div className="form-group">
              <label className="label">Message *</label>
              <textarea className="input" rows={5} placeholder="Write your announcement here…" value={form.body} onChange={e => setForm(p=>({...p,body:e.target.value}))} style={{ resize:'vertical' }} required />
            </div>
            <div className="form-group">
              <label className="label">Send to</label>
              <select className="select" value={form.target} onChange={e => setForm(p=>({...p,target:e.target.value}))}>
                <option value="all">All (members + trainers)</option>
                <option value="members">Members only</option>
                <option value="trainers">Trainers only</option>
              </select>
            </div>
            <button className="btn-primary" type="submit" disabled={saving} style={{ width:'100%', justifyContent:'center' }}>{saving ? 'Posting…' : 'Post announcement'}</button>
          </form>
        </div>
      </div>
    </div>
  );
}
